import FulfillmentIndex from "@/components/billing/fulfillment/FulfillmentIndex.vue";
import FulfillmentAdd from "@/components/billing/fulfillment/FulfillmentAdd.vue";
import FulfillmentDetail from "@/components/billing/fulfillment/FulfillmentDetail.vue";
import FulfillmentEdit from "@/components/billing/fulfillment/FulfillmentEdit.vue";

let routesFulfillmentAccess= [
    {
        path: '',
        meta: {
          title: "List Fulfillment",
        },
        name: "FulfillmentIndex",
        component: FulfillmentIndex
    },
    {
        path: 'create',
        meta: {
          title: "Create Fulfillment",
        },
        name: "FulfillmentAdd",
        component: FulfillmentAdd
    },
     
    {
        path: 'detail/:id',
        meta: {
          title: "Detail Fulfillment",
        },
        name: "FulfillmentDetail",
        component: FulfillmentDetail
    },
     
    {
        path: 'edit/:id',
        meta: {
          title: "Edit Fulfillment",
        },
        name: "FulfillmentEdit",
        component: FulfillmentEdit
    },
    
]

export default routesFulfillmentAccess
  